import { render } from "./CookieConsentBanner.vue?vue&type=template&id=c674c422"
import script from "./CookieConsentBanner.vue?vue&type=script&lang=js"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__